import { render, staticRenderFns } from "./UserDashboard.vue?vue&type=template&id=b9f78e16"
import script from "./UserDashboard.vue?vue&type=script&lang=js"
export * from "./UserDashboard.vue?vue&type=script&lang=js"
import style0 from "./UserDashboard.vue?vue&type=style&index=0&id=b9f78e16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports